// Peran per cabang (lihat src/utils/perancabang.js di server): Trainer & Team Leader bisa
// berbeda per cabang — mis. trainer di BR01 sekaligus team leader di BR07. Login mengirim
// `roles` tiap cabang; halaman hanya menawarkan cabang yang cocok dengan peran yang sedang
// dipakai. Peran lain (admin, staff, management) tetap per akun, jadi semua cabangnya.

export const PERAN_CABANG = ["trainer", "team_leader"];

export const NAMA_PERAN = {
  trainer: "Trainer",
  team_leader: "Team Leader",
  admin: "Admin",
  staff: "Staff",
  management: "Management"
};

/** Cabang yang bisa dibuka dengan peran ini. Sesi lama (cabang tanpa `roles`) = semua cabang. */
export function cabangUntukPeran(user, peran) {
  const semua = (user && user.branches) || [];
  if (!PERAN_CABANG.includes(peran)) return semua;
  return semua.filter((b) => !Array.isArray(b.roles) || b.roles.includes(peran));
}

/**
 * Cabang yang dibuka saat peran ini dipakai: yang sebelumnya bila masih boleh, satu-satunya
 * pilihan bila hanya satu, selain itu null (pilih dulu di layar cabang).
 */
export function cabangAwal(user, peran, sebelumnya) {
  const pilihan = cabangUntukPeran(user, peran);
  const sama = sebelumnya ? pilihan.find((b) => b.id === sebelumnya.id) : null;
  if (sama) return sama;
  return pilihan.length === 1 ? pilihan[0] : null;
}
